<template>
  <el-popover
    width="250"
    v-model="popoverVisible"
    :disabled="!multiple"
    class="popperClass"
    :placement="placement"
    @show="popperShow"
  >
    <div @click="popoverClick">
      <p style="margin: 0; color: #AB0033; border-bottom: 1px solid #ccc">
        已选数据
      </p>
      <ul class="popoverBox">
        <li size="mini" v-for="(item, index) in selectData" :key="index">
          {{ item.label }}
          <i class="el-icon-circle-close" @click="del(item.value)"></i>
        </li>
      </ul>
    </div>
    <el-select
      ref="popoverSelect"
      slot="reference"
      v-model="selectValue"
      filterable
      clearable
      @change="change"
      @visible-change="visibleChange"
      :placeholder="placeholder"
      :multiple="multiple"
      :collapse-tags="multiple"
      :disabled="disabled"
      :popper-append-to-body="appendToBody"
    >
      <el-option value label="全部" v-if="showAllOption"></el-option>
      <el-option
        v-for="item in allDictData"
        :key="item.id"
        :value="item.id"
        :label="item.name"
      ></el-option>
    </el-select>
    <i
      v-show="multiple && selectData.length > 0"
      slot="reference"
      :class="[
        popoverVisible ? 'showIcon' : 'hideIcon',
        'el-icon-view',
        'showPopoverIcon',
      ]"
      @click="showPopover"
    ></i>
  </el-popover>
</template>
<script>
import { filter } from 'lodash';
export default {
  props: {
    status: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    value: {
      default: '',
    },
    showAllOption: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selectDictData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      default: true,
      type: Boolean,
    },
    supplierType: {
      type: String,
      default: ''
    }
  },
  data: vm => ({
    popoverVisible: false,
    placement: 'right-start',
    selectData: [],
    allDictData: [],
    selectValue: vm.value,
  }),
  watch: {
    value: function (val) {
      if (!val || val === '') this.selectData = [];
      if (this.multiple && val) {
        this.selectData = [];
        val.forEach(item => {
          this.selectData.push({
            label: this.allDictData.filter(el => el.id === item)[0].name,
            value: item,
          });
        });
      }
      return (this.selectValue = val);
    },
  },
  beforeMount() {
    this.getAllData();
  },
  methods: {
    getAllData () {
      if (this.selectDictData.length > 0) {
        this.allDictData = this.selectDictData;
      } else {
        this.$http.setting.getSupplierUserList({}).then(result => {
          this.allDictData = result.data.map(item => ({
            id: item.code,
            name: item.name,
          }))
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
      }
    },
    /* getAllData() {
      if (this.selectDictData.length > 0) {
        this.allDictData = this.selectDictData;
      } else {
        const { userSupplier, userSelf } = this.$store.getters;
        // 外部供应商
        if (userSupplier.customerId === '1') {
          this.$http.setting
            .getByCode(userSupplier.supplierCode)
            .then(result => {
              this.allDictData = [
                {
                  id: userSupplier.supplierCode,
                  name: result.data.name,
                },
              ];
            })
            .catch(err => {
              this.$message.error(err.msg);
            });
        } else {
          // 内部用户——管理员
          if(['2', '1'].includes(this.$store.getters.userSelf.user.adminType)) {
            this.$http.setting
              .getAllSupplierList({})
              .then(result => {
                if(this.supplierType) {
                  this.allDictData = result.data.filter(item => item.category === this.supplierType).map(item => {
                    return {
                      id: item.code,
                      name: item.name,
                    };
                  });
                } else {
                  this.allDictData = result.data.map(item => {
                    return {
                      id: item.code,
                      name: item.name,
                    };
                  });
                }
              })
              .catch(err => {
                this.$message.error(err.msg);
              });
          } else {
            // 内部用户——其他
            this.$http.setting
              .getListAllByUserId(userSelf.user.id)
              .then(result => {
                this.allDictData = result.data.map(item => {
                  return {
                    id: item.supplierCode,
                    name: item.supplierName,
                  };
                });
              })
              .catch(err => {
                this.$message.error(err.msg);
              });
          }
        }
      }
    }, */
    popperShow() {
      this.getAllData();
    },
    change(val) {
      setTimeout(() => {
        if (this.selectData.length < 1) this.popoverVisible = false;
      }, 100);
      if (this.multiple) {
        this.$emit('change-emit', this.selectValue);
      } else {
        this.$emit(
          'change-emit',
          this.selectValue,
          this.allDictData.find(item => item.id === this.selectValue).name,
        );
      }
      // 选择时，清空同步方案
      this.$emit('table-select', val);
    },
    visibleChange() {
      if (this.selectData.length > 0) this.placement = 'right-start';
    },
    del(val) {
      this.selectValue = filter(this.selectValue, n => val !== n);
      if (this.multiple) {
        this.$emit('change-emit', this.selectValue);
      } else {
        this.$emit(
          'change-emit',
          this.selectValue,
          this.allDictData.find(item => item.id === this.selectValue).name,
        );
      }

      if (this.selectValue.length < 1) this.popoverVisible = false;
    },
    // 阻止下拉框隐藏
    popoverClick() {
      if (this.selectValue.length > 0) this.$refs.popoverSelect.focus();
    },
    // 点击图标显示弹窗
    showPopover() {
      if (this.selectValue.length > 0) this.$refs.popoverSelect.focus();
      this.popoverVisible = !this.popoverVisible;
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/assets/styles/multiSelect.less';
</style>
